import { render, staticRenderFns } from "./index.vue?vue&type=template&id=073cf59b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073cf59b')) {
      api.createRecord('073cf59b', component.options)
    } else {
      api.reload('073cf59b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=073cf59b", function () {
      api.rerender('073cf59b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/courseSet/index.vue"
export default component.exports